export default __webpack_public_path__ + "static/media/4.20a5e9f5.jpg";